import { Route, Routes } from "react-router-dom";
import AppLayout from "../templates/layouts/AppLayout";
import LoginLayout from "../templates/layouts/LoginLayout";
import Loadable from "@shared/hooks/router/Loadable";
import PrivateRoute from "./PrivateRoutes";
import { useSocket } from "@conductor/hooks/useSocket";
import { useEffect } from "react";
import { useAuth } from "@conductor/context/AuthContext";
import { usePerfilesContext } from "@conductor/context/PerfilesContext";
import useIdlePrefetch from "@shared/hooks/router/useIdlePrefetch";

const PageHome = Loadable(() => import("../modules/home/PageHome"));
const PageLogin = Loadable(() => import("../modules/login/PageLogin"));
const PageActivateAccount = Loadable(() => import("../modules/login/PageActivateAccount"));
const PageOlvideMiPassword = Loadable(() => import("../modules/login/PageOlvideMiContrasena"));
const PageRestablecerPassword = Loadable(() => import("../modules/login/PageRestablecerContrasena"));
const PageMapChofer = Loadable(() => import("../modules/map-chofer/PageMapChofer"));
const PageNotifications = Loadable(() => import("../modules/notifications/PageNotifications"));
const PageHistoricalChofer = Loadable(() => import("../modules/historical-chofer/PageHistorical"));
const PageSecurity = Loadable(() => import("../modules/security/PageSecurity"));
const PageInformacionPersonal = Loadable(() => import("../modules/informacion-personal/PageInformacionPersonal"));
const PageAssignedItems = Loadable(() => import("@conductor/modules/assigned-items/PageAssignedItems"));



const Router = () => {
	const { userData } = useAuth();
	const { socket, emit } = useSocket([]);
	const { perfil } = usePerfilesContext();

	useEffect(() => {
		if (!userData || !perfil) return;
		const data = { ...userData, perfil }
		emit('setup', data);
	}, [socket, userData, perfil]);

	useIdlePrefetch([
		() => PageHome.preload(),
		() => PageMapChofer.preload(),
		() => PageNotifications.preload(),
		() => PageHistoricalChofer.preload(),
		() => PageSecurity.preload(),
		() => PageInformacionPersonal.preload(),
		() => PageLogin.preload(),
	])

	return (<>
		<Routes>
			<Route path='/' element={<PrivateRoute />}>
				<Route path='/' element={<AppLayout />}>
					<Route path={'/'} element={<PageHome />} />
					<Route path={'/mapa-chofer'} element={<PageMapChofer />} />
					<Route path={'/notificaciones'} element={<PageNotifications />} />
					<Route path={'/seguridad'} element={<PageSecurity />} />
					<Route path={'/informacion-personal'} element={<PageInformacionPersonal />} />
					<Route path={'/historico-chofer'} element={<PageHistoricalChofer />} />
					<Route path={'/assigned-items'} element={<PageAssignedItems />} />
				</Route>
			</Route>
			<Route path='/' element={<LoginLayout />}>
				<Route path="/activate-account/:hash" element={<PageActivateAccount />} />
				<Route path="/activate-account/:redirect/:hash" element={<PageActivateAccount />} />
				<Route path="/olvide-mi-password" element={<PageOlvideMiPassword />} />
				<Route path="/restablecer-password/:hash" element={<PageRestablecerPassword />} />
				<Route path="/login" element={<PageLogin />} />
			</Route>
		</Routes >
	</>
	);
};

export default Router;